import React from "react";


export default function Backup(props) {
  const banner = props.banner;
  const backup = [];
  try {
    banner.elements.forEach(element => {
      if (!element.out) backup.push(element);    
    });
  } catch(error) { }

  props.banner.elements.forEach(element => {
    if (element.parent) {
      const index = props.banner.elements.findIndex(x => x.id === element.parent);
      element.properties.top = parseInt(props.banner.elements[index].properties.top) + parseInt(element.properties.top);
      element.properties.left = parseInt(props.banner.elements[index].properties.left) + parseInt(element.properties.left);
    }
  });

  return (
    <div
      id={"replica_" + banner.width + "x" + banner.height + "_backup"}
      style={{
        zIndex: -1,
        display: 'none',
        width: `${banner.width}px`,
        height: `${banner.height}px`,
        position: 'absolute',
        background: banner.backgroundColor ? banner.backgroundColor : 'white',
        top: '0px',
        left: '0px'
      }}>
    {props.banner.elements.map(item =>
      !item.out && item.enabled ?
      <div
        key={Math.random()}
        style={{        
          width: `${item.properties.width}px`,
          height: `${item.properties.height}px`,
          background: item.properties.background ? `url('${item.properties.background}') no-repeat`: "",
          position: 'absolute',
          top: `${item.properties.top}px`,
          left: `${item.properties.left}px`
        }}>
      </div> : <></>
    )}
  </div>
  )
}